const MERCHANT_INVOICES = "MERCHANT_INVOICES";
const MERCHANT_INVOICES_SUCCESS = "MERCHANT_INVOICES_SUCCESS";
const MERCHANT_INVOICES_FAILURE = "MERCHANT_INVOICES_FAILURE";
const CLEAR_MERCHANT_INVOICES = "CLEAR_MERCHANT_INVOICES";

const MerchantInvoicesSymbols = {
  MERCHANT_INVOICES_SUCCESS,
  MERCHANT_INVOICES_FAILURE,
  MERCHANT_INVOICES,
  CLEAR_MERCHANT_INVOICES,
};
export default MerchantInvoicesSymbols;
